// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "e23d6a1",
    "hash": "e23d6a1",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "e23d6a1",
    "semverString": null,
    "version": "3.31.0"
};
